
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer,
  Legend 
} from 'recharts';

interface ExpensesChartProps {
  data: Array<{
    month: string;
    water: number;
    electricity: number;
    other: number;
  }>;
}

const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP'
  }).format(value);
};

const ExpensesChart = ({ data }: ExpensesChartProps) => {
  return (
    <Card className="lg:col-span-2 flex flex-col h-[400px] lg:h-auto">
      <CardHeader className="p-3">
        <CardTitle className="text-xl">Gastos mensuales de servicios</CardTitle>
      </CardHeader>
      <CardContent className="p-3 flex-1">
        <div className="w-full h-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart 
              data={data}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 65
              }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: 'white',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px'
                }}
                formatter={(value: number) => [formatCurrency(value), '']}
              />
              <Legend 
                verticalAlign="bottom" 
                height={36}
                iconType="circle"
                formatter={(value) => {
                  const labels = {
                    water: "Agua",
                    electricity: "Electricidad",
                    other: "Otros"
                  };
                  return <span className="text-xs font-medium">{labels[value as keyof typeof labels]}</span>;
                }}
              />
              <Bar 
                dataKey="water" 
                fill="#0EA5E9" 
                name="water" 
                radius={[4, 4, 0, 0]}
              />
              <Bar 
                dataKey="electricity" 
                fill="#EAB308" 
                name="electricity" 
                radius={[4, 4, 0, 0]}
              />
              <Bar 
                dataKey="other" 
                fill="#94a3b8" 
                name="other" 
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default ExpensesChart;
